export enum WeekStrongFormatterBlock {
  Root = 'WeekStrongFormatter',
}

export enum WeekStrongFormatterElement {
  Point = 'point',
}
